import type { ConnectionSlice, ConnectionState, ViewerSliceCreator } from "./types";

export const connectionInitialState: ConnectionState = {
  connected: false,
};

export const createConnectionSlice: ViewerSliceCreator<ConnectionSlice> = (set) => ({
  ...connectionInitialState,

  setConnected: (connected) =>
    set((state) => {
      state.connected = connected;
    }),
});
